// libraries.
import { useState } from "react";
import { Spinner } from "react-bootstrap";

// shared.
import { Tab } from "@shared/Tabs";
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";

// assets.
import { IconWarning, IconMoney, IconSummary } from "@assets";

// styles.
import { electricPurple600, monserratSemiBold, scarpaGray500 } from "@habitech/shared";
import { StyledTabsContainer } from "../styles";

// components.
import { ExceptionsTab } from "./ExceptionsTab";
import { IncentiveRouteTab } from "./IncentiveRouteTab";
import { SummaryTab } from "./SummaryTab";

// store.
import { useGetRules } from "@store/apiSlices/incentiveRules/rules.hook";

enum RulesTabEnum {
  Exceptions = "exceptions",
  IncentiveRoute = "incentive-route",
  Summary = "summary",
}

const tabsConfig = [
  {
    tab: RulesTabEnum.Exceptions,
    label: "Excepciones",
    Icon: IconWarning,
    Component: ExceptionsTab,
  },
  {
    tab: RulesTabEnum.IncentiveRoute,
    label: "Ruta de Incentivos",
    Icon: IconMoney,
    Component: IncentiveRouteTab,
  },
  {
    tab: RulesTabEnum.Summary,
    label: "Resumen",
    Icon: IconSummary,
    Component: SummaryTab,
  },
];

export const RulesTabs = () => {
  const [activeTab, setActiveTab] = useState<RulesTabEnum>(
    RulesTabEnum.Exceptions
  );
  const { country } = useUserProfile();
  const { isLoading, isFetching } = useGetRules(country || "CO");
  const loading = isLoading || isFetching;

  return (
    <StyledTabsContainer className="d-flex flex-column flex-grow-1 overflow-hidden">
      <div className="d-flex tabs-header flex-shrink-0">
        {tabsConfig.map(({ tab, label, Icon }) => (
          <Tab
            key={tab}
            active={activeTab === tab}
            icon={
              <Icon
                fill={activeTab === tab ? electricPurple600 : scarpaGray500}
              />
            }
            onClick={() => setActiveTab(tab)}
            title={<span style={{ fontFamily: monserratSemiBold, fontWeight: 600 }}>{label}</span>}
          />
        ))}
      </div>

      <div className="tabs-content">
        {loading ? (
          <div className="tabs-loader">
            <Spinner animation="border" variant="secondary" />
          </div>
        ) : (
          tabsConfig.map(({ tab, Component }) => (
            <div key={tab}>{activeTab === tab && <Component />}</div>
          ))
        )}
      </div>
    </StyledTabsContainer>
  );
};

